import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const AppShell: React.FC = () => {
  return (
    <div className="simb-app-shell">
      <main className="simb-app-content">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default AppShell;